export const ALGOLIA_KEY_SEARCH_RESULTS = 'search-results'
export const ALGOLIA_KEY_MAIN = 'main'

export const ALGOLIA_KEYS = [
  ALGOLIA_KEY_SEARCH_RESULTS,
  ALGOLIA_KEY_MAIN,
]
